import React from 'react';
import { Grid, TextField, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

const PasswordChangeForm = ({ passwords, handleChange, handleSubmit }) => {
  const { t } = useTranslation();

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t('password.current')}
            name="old_password"
            type="password"
            value={passwords.old_password}
            onChange={handleChange}
            variant="outlined"
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t('password.new')}
            name="new_password"
            type="password"
            value={passwords.new_password}
            onChange={handleChange}
            variant="outlined"
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t('password.confirm')}
            name="confirm_password"
            type="password"
            value={passwords.confirm_password}
            onChange={handleChange}
            variant="outlined"
            required
          />
        </Grid>
        <Grid item xs={12}>
          <Button type="submit" variant="contained" color="primary">
            {t('password.submit')}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default PasswordChangeForm;
